<template>
  <SmallSquare class="" content='1、可用于自动回复、自定义菜单、一对一回复等，不能与微信公众平台的微信图文同步，也不受微信素材数量限制。
  2、关键词、扫码、自定义菜单等回复，推荐使用高级图文。
  3、高级图文支持链接跳转的方式，前端点击图文，直接跳转到设定的链接地址。'></SmallSquare>
  <div class="s_flex_bian_c m-t-25">
    <a-button type="primary" v-has:highDrewManagementCreate="()=>{$router.push('/wxPublic/wxManagement/drewManagement/high_imgText_add?type=add')}">
      <PlusOutlined />
      新建高级图文
    </a-button>
    <div class="s_flex_ali">
      <a-input v-model:value="search.keyword" style="width: 300px;" placeholder="请输入关键词进行搜索" />
      <a-button class="m-l-15" type="primary" @click="onSearch">搜索</a-button>
    </div>
  </div>
  <a-spin :spinning="listLoading">
    <div class="m-t-25 s_bor_cbed s_bor10 s_over_h s_borList" v-if='msgList.length > 0'>
      <div class="p-t-15 p-b-15 p-l-20 p-r-20 s_flex_bian_c s_bb1 s_borListItem" v-for='item in msgList' :key='item'>
        <div class="width40 s_flex_ali">
          <img class="width-100 height-100 m-r-20" :src="info.picdomain+'/'+item.list[0].image" alt="">
          <p class="s_c333 s_omit width30">{{item.list[0].title}}</p>
        </div>
        <p class="s_c999 flex_1">{{item.create_time}}</p>
        <div class="width10 s_flex_bian_c">
          <a class="width30 text_ac" href="javascript:;" v-has:highDrewManagementEdit="()=>{$router.push('/wxPublic/wxManagement/drewManagement/high_imgText_add?type=edit&id='+item.id)}">编辑</a>
          <a class="width30 text_ac" href="javascript:;" v-has:highDrewManagementDel='()=>listDel(item.id)'>删除</a>
        </div>
      </div>
    </div>
    <a-empty class="m-t-30" v-else />
  </a-spin>
  <a-pagination :style="{marginTop:'25px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
</template>
<script>
  import { PlusOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import {getWxGraphicSenior,wxGraphicSeniorDel} from '@/api/public_wx'
  import store from "@/store";
  let defSearch = {
    page: 1,
    limit: 10,
    keyword:"",
  };
  export default {
    name: 'wxImgText',
    components: { PlusOutlined },
    setup(props) {
      const search = ref({ ...defSearch });
      const state = reactive({
        listLoading:false,
        total: 1,
        msgList: [],
        info: store.state.user.info,
      });
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const listDel = (e) =>{
        $Modal.confirm({
          centered:true,
          title:'高级图文删除',
          content: '删除后该高级图文将无法恢复，您确定要删除该高级图文吗？', onOk:async () => {
            let res = await wxGraphicSeniorDel({id:e}).then(res => res.data);
            if (iscode(res,true)) {
              initData(search.value);
            }
          }
        })
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getWxGraphicSenior(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            state.msgList = res.data.data;
            state.total = res.data.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      const onSearch=()=>{
        search.value.page=1
        initData(search.value);
      }
      onMounted(() => {
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        onSearch,
        pageCurrentChange,
        pageSizeChange,
        listDel
      };
    },
  };
</script>